<template>
  <v-container>
    <!-- Título principal con animación -->
    <v-row class="header-row text-center fade-slide-down" >
      <v-col cols="12" md="10" lg="8" class="mx-auto">
        <h2 class="header-title">
          Las coberturas perfectas para ti y tu familia
        </h2>
        <p class="header-subtitle grey--text">
          Consulta externa, urgencias médicas, dental y visual.<br />
          Protección real para lo que sí importa.
        </p>
      </v-col>
    </v-row>

    <!-- Coberturas animadas con stagger y hover -->
    <v-row class="justify-center" dense>
      <v-col
        v-for="(item, i) in coberturas"
        :key="i"
        cols="6"
        md="3"
        class="px-2 py-3"
        :style="{ animationDelay: (i * 0.15) + 's' }"
      >
        <v-card
          class="pa-3 text-center animated-card"
          elevation="2"
          @mouseover="hoverIndex = i"
          @mouseleave="hoverIndex = null"
          :class="{ 'hover-card': hoverIndex === i }"
        >
          <v-icon
            size="40"
            color="primary"
            class="mb-2 icon-scale"
            :class="{ 'icon-hover': hoverIndex === i }"
          >
            {{ item.icon }}
          </v-icon>
          <div class="font-weight-medium text-subtitle-1">{{ item.titulo }}</div>
          <div class="caption grey--text">{{ item.descripcion }}</div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SeccionCobComponent",
  data() {
    return {
      hoverIndex: null,
      coberturas: [
        {
          icon: "mdi-stethoscope",
          titulo: "Consulta Médica",
          descripcion: "Atención con médicos especialistas certificados.",
        },
        {
          icon: "mdi-hospital",
          titulo: "Urgencias Médicas",
          descripcion: "Cobertura para emergencias por enfermedad o accidente.",
        },
        {
          icon: "mdi-tooth-outline",
          titulo: "Atención Dental",
          descripcion: "Servicios dentales con especialistas en ortodoncia y más.",
        },
        {
          icon: "mdi-glasses",
          titulo: "Salud Visual",
          descripcion: "Exámenes de la vista y lentes a precios preferentes.",
        },
      ],
    };
  },
};
</script>

<style scoped>
/* Animación título fade y slide down */
.fade-slide-down {
  animation: fadeSlideDown 0.8s ease forwards;
  opacity: 0;
  transform: translateY(-30px);
}

@keyframes fadeSlideDown {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Animación de cards con stagger */
.animated-card {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.5s ease forwards;
  transition: box-shadow 0.3s ease, transform 0.3s ease;
  will-change: transform, box-shadow;
}

/* Hover efecto elevación y escala */
.hover-card {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-6px) scale(1.04);
  background-color: #ede7f6 !important; /* light indigo */
}

/* Icono escala */
.icon-scale {
  transition: transform 0.3s ease;
}

.icon-hover {
  transform: scale(1.3);
}

/* Animación fadeInUp */
@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
